import { Layout } from "@/components/layout/Layout";
import { PageHero } from "@/components/shared/PageHero";
import { LeadForm } from "@/components/shared/LeadForm";

export default function Contato() {
  return (
    <Layout>
      <PageHero
        title="Entre em contato"
        subtitle="Agende uma demonstração, tire dúvidas ou fale diretamente com nosso time comercial."
      />

      <section className="section-padding section-alt">
        <div className="container-wide max-w-xl mx-auto">
          <LeadForm
            title="Agende uma demonstração"
            description="Preencha o formulário e nosso time entrará em contato em até 24 horas úteis."
          />
        </div>
      </section>
    </Layout>
  );
}